var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublicSpeaking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2724_64263",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2724_64263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.95 15.95L18.4 14.4C19.1333 13.7167 19.7083 12.9084 20.125 11.975C20.5417 11.0417 20.75 10.05 20.75 9.00005C20.75 7.95005 20.5417 6.96672 20.125 6.05005C19.7083 5.13338 19.1333 4.33338 18.4 3.65005L19.95 2.05005C20.8833 2.93338 21.625 3.97505 22.175 5.17505C22.725 6.37505 23 7.65005 23 9.00005C23 10.35 22.725 11.625 22.175 12.825C21.625 14.025 20.8833 15.0667 19.95 15.95ZM16.75 12.75L15.15 11.15C15.45 10.8667 15.6917 10.5459 15.875 10.1875C16.0583 9.82922 16.15 9.43338 16.15 9.00005C16.15 8.56672 16.0583 8.17088 15.875 7.81255C15.6917 7.45422 15.45 7.13338 15.15 6.85005L16.75 5.25005C17.2833 5.73338 17.7 6.29588 18 6.93755C18.3 7.57922 18.45 8.26672 18.45 9.00005C18.45 9.73338 18.3 10.4209 18 11.0625C17.7 11.7042 17.2833 12.2667 16.75 12.75ZM9 13C7.9 13 6.95833 12.6084 6.175 11.825C5.39167 11.0417 5 10.1 5 9.00005C5 7.90005 5.39167 6.95838 6.175 6.17505C6.95833 5.39172 7.9 5.00005 9 5.00005C10.1 5.00005 11.0417 5.39172 11.825 6.17505C12.6083 6.95838 13 7.90005 13 9.00005C13 10.1 12.6083 11.0417 11.825 11.825C11.0417 12.6084 10.1 13 9 13ZM1 21V18.2C1 17.65 1.14167 17.1334 1.425 16.65C1.70833 16.1667 2.1 15.8 2.6 15.55C3.45 15.1167 4.40833 14.75 5.475 14.45C6.54167 14.15 7.71667 14 9 14C10.2833 14 11.4583 14.15 12.525 14.45C13.5917 14.75 14.55 15.1167 15.4 15.55C15.9 15.8 16.2917 16.1667 16.575 16.65C16.8583 17.1334 17 17.65 17 18.2V21H1ZM3 19H15V18.2C15 18.0167 14.9542 17.85 14.8625 17.7C14.7708 17.55 14.65 17.4334 14.5 17.35C13.9 17.05 13.1292 16.75 12.1875 16.45C11.2458 16.15 10.1833 16 9 16C7.81667 16 6.75417 16.15 5.8125 16.45C4.87083 16.75 4.1 17.05 3.5 17.35C3.35 17.4334 3.22917 17.55 3.1375 17.7C3.04583 17.85 3 18.0167 3 18.2V19ZM9 11C9.55 11 10.0208 10.8042 10.4125 10.4125C10.8042 10.0209 11 9.55005 11 9.00005C11 8.45005 10.8042 7.97922 10.4125 7.58755C10.0208 7.19588 9.55 7.00005 9 7.00005C8.45 7.00005 7.97917 7.19588 7.5875 7.58755C7.19583 7.97922 7 8.45005 7 9.00005C7 9.55005 7.19583 10.0209 7.5875 10.4125C7.97917 10.8042 8.45 11 9 11Z",
    fill: "#707072"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicSpeaking);
export default __webpack_public_path__ + "static/media/Public Speaking.d58f88b8.svg";
export { ForwardRef as ReactComponent };